import React from "react";
import { useUser } from "../../../../context/AuthContext";
import Scope3ApprovalListCore from "../Scope3ApprovalListCore";
import SimpleScope3ApprovalDrawer from "../SimpleScope3ApprovalDrawer";

/** Approval list often includes populated `franchiseMasterData`; legacy rows may use `franchiseMaster` object or flat fields. */
const mapFranchisesApprovalRow = (item) => {
  const fmd = item?.franchiseMasterData;
  const fm =
    item?.franchiseMaster && typeof item.franchiseMaster === "object"
      ? item.franchiseMaster
      : null;

  return {
    ...item,
    franchiseName:
      fmd?.franchiseName ?? fm?.franchiseName ?? item?.franchiseName ?? "",
    country: fmd?.country ?? fm?.country ?? item?.country ?? "",
  };
};

const FranchisesView = (props) => (
  <SimpleScope3ApprovalDrawer {...props} title="Franchises — change request" />
);

const FranchisesApproval = () => {
  const { user } = useUser();

  const headings = [
    { title: "Date", key: "createdAt" },
    user?.companyAdmin ? { title: "Facility", key: "facilityName" } : null,
    { title: "Franchise Name", key: "franchiseName" },
    { title: "Country", key: "country" },
    // { title: "Franchise Type", key: "franchiseType" },
    { title: "Status", key: "requestStatus" },
    { title: "Created By", key: "createdBy" },
  ].filter(Boolean);

  return (
    <Scope3ApprovalListCore
      pageTitle="Franchises"
      apiSegment="franchises"
      ViewPage={FranchisesView}
      headings={headings}
      columnWidth={
        user?.companyAdmin
          ? "11% 14% 14% 14% 14% 14% 9%"
          : "12% 20% 20% 18% 18% 8%"
      }
      mapRow={mapFranchisesApprovalRow}
    />
  );
};

export default FranchisesApproval;
